<template>
  <Chart type="line" :data="chartData" :options="chartOptions" style="height: 400px;" />
</template>

<script>
import Chart from 'primevue/chart'

export default {
  components: {
    Chart
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    unit: {
      type: String,
      required: true
    }
  },
  computed: {
    chartData () {
      const labels = Object.keys(this.range).map(dateStr => {
        const date = new Date(dateStr)
        return date.toLocaleDateString('de-DE', {
          day: '2-digit',
          month: 'short'
        })
      })
      const data = Object.keys(this.range).map(date =>
        parseFloat(String(this.range[date]).replace(',', '.'))
      )
      return {
        labels,
        datasets: [{
          type: 'line',
          borderColor: '#0DAC50',
          borderWidth: 4,
          fill: true,
          backgroundColor: '#86D6A8',
          tension: 0.4,
          cubicInterpolationMode: 'monotone',
          pointRadius: 0,
          data
        }]
      }
    }
  },
  data () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            grid: { display: false }
          },
          y: {
            grid: { display: false },
            ticks: {
              callback: (value) => {
                return `${Number(value).toFixed(2)}${this.unit}`
              }
            }
          }
        }
      }
    }
  }
}
</script>
